<div class="icon-branding">
  <svg-icon *ngIf="productResourceful" src="/assets/logo/resourceful-with-tag.svg"></svg-icon>
  <svg-icon *ngIf="productPurposeful" src="/assets/logo/purposeful-with-tag.svg"></svg-icon>
</div>
